<template>
  <ValidationProvider :rules="rules" :vid="prefixLabel + ' ' + label" immediate v-slot="{ failed }">
    <md-field :class="{ 'md-error': failed, 'md-form-group': icon, disabled, outline, dynamic }" :md-clearable="clearable">
      <md-icon v-if="icon">{{ icon }}</md-icon>
      <label>
        {{ label }}
        <span v-if="required">&nbsp;*</span>
      </label>

      <span v-if="prefix" class="md-prefix">{{ prefix }}</span>
      <md-input
        :value="value"
        v-on:input="$emit('input', $event)"
        @keyup.enter="$emit('done', $event);"
        @blur="!failed && value ? validate() : null"
        @keyup="!isMelissaCheckPassed && !failed && value ? validate() : cleanPhoneNumber($event.target.value)"
        type="type"
        autocomplete="url"
        :disabled="disabled"
        :readonly="readonly"
      >
      </md-input>
      <span v-if="suffix" class="md-suffix"><small>{{ suffix }}</small></span>

      <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
    </md-field>
    <span
      v-if="failed"
      class="error-msg"
    >
      {{ errormsg }}
    </span>
    <span
      v-if="!isMelissaCheckPassed && (melissaCheckType === 'phone' || melissaCheckType === 'email')"
      class="error-msg"
    >
    The {{ melissaCheckType }} you entered appears to be invalid or non-existent
    </span>
  </ValidationProvider>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    prefix: {
      type: String,
      default: ""
    },
    suffix: {
      type: String,
      default: ""
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    alpha: {
      type: Boolean,
      default: false
    },
    alphaDash: {
      type: Boolean,
      default: false
    },
    alphaNum: {
      type: Boolean,
      default: false
    },
    alphaSpaces: {
      type: Boolean,
      default: false
    },
    regex: {
      type: String,
      default: ""
    },
    errormsg: {
      type: String,
      default: "Please enter the correct information.",
    },
    names: {
      type: String,
      default: "",
    },
    url: {
      type: Boolean ,
      default: false,
    },
    melissaCheckType: {
      type: String,
      default: ""
    },
    outline: {
      type: Boolean,
      default: false,
    },
    dynamic: {
      type: Boolean,
      default: false,
    },
    prefixLabel: {
      type: String,
      default: "",
    },
    maxLength: {
      type: Number,
      default: 0,
    },
    minLength: {
      type: Number,
      default: 0,
    },
    immediate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rules(){

      let rules = [];
      if (this.alpha) rules.push('alpha');
      if (this.alphaNum) rules.push(`alpha_num:${this.alphaNum}`);
      if (this.alphaDash) rules.push(`alpha_dash:${this.alphaDash}`);
      if (this.alphaSpaces) rules.push(`alpha_spaces:${this.alphaSpaces}`);
      if (this.required) rules.push('required');
      if (this.regex) rules.push(`regex:${this.regex}`);
      if (this.names) rules.push('names');
      if (this.maxLength) rules.push(`max:${this.maxLength}`);
      if (this.minLength) rules.push(`min:${this.minLength}`);
      if (this.url) rules.push('url');
      if (this.melissaCheckType === "email")
        rules.push("regex:^[^'\"][_a-zA-Z0-9-]*(\.[^'\"][_a-zA-Z0-9-]*)*@[^'\"][a-zA-Z0-9-]*(\.[^'\"][a-zA-Z0-9-]*)*(\.[^'\"][a-zA-Z])*$");
      if (this.melissaCheckType === "phone")
        rules.push("regex:^[0-9]*$");

      return rules.join('|');
    },
  },
  data() {
    return {
      isMelissaCheckPassed: true
    };
  },
  methods: {
    cleanPhoneNumber(val) {
      if( this.melissaCheckType === 'phone') {
        const cleanedPhoneNumber = val.replace(/\s/g, ''); // Remove spaces from phone number
        this.$emit('input', cleanedPhoneNumber);
      }
    },
    async validate() {
      if ((this.melissaCheckType === 'phone' || this.melissaCheckType === 'email') && 
        this.value && this.value.trim() !== "") {
        try {
          const response = await axios.post(`/api/v1/validate-melissa-info/${this.melissaCheckType}`, {
            type: this.melissaCheckType,
            value: this.value,
          });
          this.isMelissaCheckPassed = response.data.valid
          this.$emit('is-melissa-check-passed-changed', this.isMelissaCheckPassed);
        } catch (error) {
          console.error('Error:', error);
        }
      }
    },
  },

  /** The script below is a temp solution to add a placeholder to the Datepicker fields
  * The setTimeout function is used to delay the call by 100 milliseconds as it was being overwritten
  * */

  mounted(){
    let element = this.$el.querySelector('.date-input div input');
    if (element) {
      setTimeout(function(){ element.placeholder = 'YYYY-MM-DD'; }, 100);
    }
    if (this.immediate) {
      this.validate();
    }
  },
  updated(){
    let element = this.$el.querySelector('.date-input div input');
    if (element) {
      setTimeout(function(){ element.placeholder = 'YYYY-MM-DD'; }, 100);
    }
  },
};
</script>

<style lang="scss" scoped>
  .disabled{
    opacity: 0.7;
  }
</style>
